export default __webpack_public_path__ + "static/media/bg_blob.de183e26.svg";